/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactResponseData,
  CreateContactResponseDataFromJSON,
  CreateContactResponseDataFromJSONTyped,
  CreateContactResponseDataToJSON
} from './CreateContactResponseData'

/**
 *
 * @export
 * @interface UpdateContactNoReplyRequiredChatResponse
 */
export interface UpdateContactNoReplyRequiredChatResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateContactNoReplyRequiredChatResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactResponseData}
   * @memberof UpdateContactNoReplyRequiredChatResponse
   */
  data?: CreateContactResponseData
}

export function UpdateContactNoReplyRequiredChatResponseFromJSON(json: any): UpdateContactNoReplyRequiredChatResponse {
  return UpdateContactNoReplyRequiredChatResponseFromJSONTyped(json, false)
}

export function UpdateContactNoReplyRequiredChatResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateContactNoReplyRequiredChatResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactResponseDataFromJSON(json['data'])
  }
}

export function UpdateContactNoReplyRequiredChatResponseToJSON(
  value?: UpdateContactNoReplyRequiredChatResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactResponseDataToJSON(value.data)
  }
}
